import { useRef } from "react";
import { useInView } from "framer-motion";
import { Link } from "react-router-dom";
import { Smartphone } from "lucide-react";
import { formatPrice, categoryOf, byModel, isNewCond } from "@/lib/store";
import { AppleMark, isAllOriginal } from "./PartsInfo";

const MiniCard = ({ p, hidden }) => (
  <Link to={`/produto/${p.id}`} tabIndex={hidden ? -1 : undefined} aria-hidden={hidden || undefined} data-testid={hidden ? undefined : `top-carousel-item-${p.id}`}
    className="group mr-4 flex w-[375px] shrink-0 items-center gap-4 rounded-3xl border border-white/10 bg-[#111113]/80 p-3 pr-6 transition-colors duration-300 hover:border-white/30">
    <div className="h-[84px] w-[84px] shrink-0 overflow-hidden rounded-2xl bg-zinc-900">
      {p.images?.[0] ? <img src={p.images[0]} alt={p.model} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" /> : <Smartphone className="m-auto mt-7 h-7 w-7 text-zinc-500" />}
    </div>
    <div className="min-w-0">
      <p className="truncate text-lg font-bold text-white">{p.model}</p>
      <p className="truncate text-sm text-zinc-400">{[p.storage, isNewCond(p.condition) ? "Novo" : "Seminovo"].filter(Boolean).join(" · ")}</p>
      <div className="mt-1 flex items-center gap-2">
        <p className="whitespace-nowrap text-lg font-semibold text-white">{formatPrice(p.price)}</p>
        {isAllOriginal(p) && (
          <span data-testid={hidden ? undefined : `top-carousel-original-${p.id}`} className="flex shrink-0 items-center gap-1 rounded-full border border-white/20 bg-white/[0.06] px-2 py-0.5 text-[11px] font-medium text-white">
            <AppleMark className="h-2.5 w-2.5" /> Original Apple
          </span>
        )}
      </div>
    </div>
  </Link>
);

const Track = ({ loop, count }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { margin: "100px 0px" });
  return (
    <div ref={ref} className={`carousel-track flex w-max ${inView ? "" : "is-paused"}`} style={{ "--dur": `${loop.length * 6}s` }}>
      {loop.map((p, i) => <MiniCard key={`a-${i}`} p={p} hidden={i >= count} />)}
      {loop.map((p, i) => <MiniCard key={`b-${i}`} p={p} hidden />)}
    </div>
  );
};

export const TopCarousel = ({ products }) => {
  const items = (Array.isArray(products) ? products : []).filter((p) => categoryOf(p) === "iphone").sort(byModel);
  if (!items.length) return null;
  const loop = [];
  while (loop.length < 8) loop.push(...items);
  return (
    <section data-testid="top-carousel" aria-label="iPhones disponíveis" className="relative overflow-hidden pt-[136px] lg:pt-24">
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-12 bg-gradient-to-r from-[#09090b] to-transparent sm:w-24" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-12 bg-gradient-to-l from-[#09090b] to-transparent sm:w-24" />
      <Track loop={loop} count={items.length} />
    </section>
  );
};
